<!-- eslint-disable max-len -->
<template>
    <div
        v-show="activeSubMenu === 'more'"
        class="main-menu__submenu main-menu-submenu"
    >
        <div class="wrapper">
            <div
                :class="[
                    'main-menu-submenu__row',
                    {'main-menu-submenu__row--big': activeChapter && !activeChapter.services},
                ]"
            >
                <div
                    class="main-menu-submenu__col"
                    @click.self="toggleSubMenu('more')"
                >
                    <template v-for="item in getOtherItems(getSubItems)">
                        <n-link
                            v-if="item.isActive && !item.isExternal"
                            :key="item.slug"
                            :class="[
                                'main-menu-submenu__link',
                                {
                                    green: item.green, active: isLinkActive(getLink(item)),
                                },
                            ]"
                            :to="getLink(item)"
                        >
                            {{ item.title }}
                        </n-link>
                        <a
                            v-if="item.isActive && item.isExternal"
                            :key="item.path"
                            :class="[
                                'main-menu-submenu__link',
                                {
                                    green: item.green,
                                },
                            ]"
                            :href="item.path"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {{ item.title }}
                        </a>
                    </template>
                </div>
                <div
                    v-if="activeChapter && activeChapter.banner"
                    class="main-menu-submenu__col main-menu-submenu__popular"
                >
                    <slot name="banner" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';

import {useMainMenu} from '@/core/composables/useMainMenu';

export default defineComponent({
    name: 'TheMainMenuOtherItems',
    setup() {
        const menuComposable = useMainMenu();

        return {
            activeChapter: menuComposable.activeChapter,
            activeSubMenu: menuComposable.activeSubMenu,
            toggleSubMenu: menuComposable.toggleSubMenu,
            getSubItems: menuComposable.getSubItems,
            getLink: menuComposable.getLink,
            isLinkActive: menuComposable.isLinkActive,
            getOtherItems: menuComposable.getOtherItems,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/navigation/mainMenu';
</style>
